import React, { useState } from 'react';
import styles from './BusinessTariffsCard.module.scss';
import SliderWrapper from '../SliderWrapper/SliderWrapper';
import BusinessTariffCard from '../BusinessTariffCard/BusinessTariffCard';
import BusinessContactForm from '../BusinessContactForm/BusinessContactForm';
import Tab from '../Tabs/Tab';
import TabContentItem from '../Tabs/TabContentItem';
import TabPanel from '../Tabs/TabPanel';
import Tabs from '../Tabs/Tabs';
import TabContent from '../Tabs/TabContent';
import SectionTitle from '../SectionTitle/SectionTitle';

const BusinessTariffsCard = ({ data, tabs, title, buttonText }) => {
  const [currentTab, setCurrentTab] = React.useState(0);
  const [modalActive, setModalActive] = useState(false);
  const [sliderHeight, setSliderHeight] = useState(0);
  const [tariffID, setTariffID] = useState(null);

  const closeModal = () => {
    setModalActive(false);
    setTariffID(null);
  };

  const renderList = (item, key) => (
    <BusinessTariffCard
      changeSliderHeight={setSliderHeight}
      sliderHeight={sliderHeight}
      key={key}
      data={item}
      itemScope
      itemType='https://schema.org/Product'
    />
  );

  if (data) {
    return (
      !!data?.length && (
        <>
          <div
            className={'wrapper section'}
            itemScope
            itemType='https://schema.org/ItemList'
          >
            {title && (
              <SectionTitle titleModify='title--large' className={styles.title}>
                {title}
              </SectionTitle>
            )}
          </div>
          <SliderWrapper
            className={styles.slider}
            arrows
            options={{ infinite: data?.tariffs?.length > 2 }}
          >
            {data.map(renderList)}
          </SliderWrapper>
          <BusinessContactForm
            tariffID={tariffID}
            activeModal={modalActive}
            clearTariff={closeModal}
          />
        </>
      )
    );
  }

  const renderTab = (item, index) => {
    return (
      <Tab key={index} onClick={() => setCurrentTab(index)}>
        {item.title}
      </Tab>
    );
  };

  const renderTabItem = (item, index) => {
    return (
      <TabContentItem
        key={index}
        itemScope
        itemType='https://schema.org/ItemList'
      >
        {!!item.items?.length && (
          <SliderWrapper
            arrows
            options={{ infinite: data?.tariffs?.length > 2 }}
            className={styles.slider}
          >
            {item.items.map(renderList)}
          </SliderWrapper>
        )}
      </TabContentItem>
    );
  };

  return (
    <div
      className={'wrapper section'}
      itemScope
      itemType='https://schema.org/WebPage'
    >
      {title && (
        <SectionTitle
          titleModify='title--large'
          className={styles.title}
          buttonText={buttonText}
        >
          {title}
        </SectionTitle>
      )}
      <Tabs active={currentTab}>
        <TabPanel>{tabs.map(renderTab)}</TabPanel>
        <TabContent>{tabs.map(renderTabItem)}</TabContent>
      </Tabs>
      <BusinessContactForm
        tariffID={tariffID}
        activeModal={modalActive}
        clearTariff={closeModal}
      />
    </div>
  );
};

export default BusinessTariffsCard;
